import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../constants/appconstants';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private headers = new HttpHeaders().set('Content-Type', 'application/json');
  public value: BehaviorSubject<any> = new BehaviorSubject(false);
  public profileImageUrl: BehaviorSubject<any> = new BehaviorSubject('');
  private dataToUser$ = new Subject();
  dataToContainer$: any;

  constructor(public http: HttpClient) { }

  addHostToUrl(url: string): string {
    return `${environment.baseUrl}${url}`;
  }

  public tableCreated: BehaviorSubject<any> = new BehaviorSubject(false);
  gettableCreatedObs(): Observable<any> {
    return this.tableCreated.asObservable();
  }

  settableCreatedObs(tableCreated: any) {
    this.tableCreated.next(tableCreated);
  }

  public tableAuditView: BehaviorSubject<any> = new BehaviorSubject(false);
  gettableAuditViewObs(): Observable<any> {
    return this.tableAuditView.asObservable();
  }

  settableAuditViewObs(tableAuditView: any) {
    this.tableAuditView.next(tableAuditView);
  }

  // SSO Login API
  doGetSsoLogin(url: string, clientCode: any, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.get(url, { headers: { 'Content-Type': 'application/json', 'Client_Code': clientCode }, observe: 'response' }).subscribe(
      {
        next: (response) => {
          successCallBack(response);
        },
        error: (error) => {
          errorCallBack(error);
        },

      });
  }

  //Request with client code in header
  doPostHeaderRequestWithResponse(url: string, headers: HttpHeaders, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    this.http.post(url, {}, {
      headers: headers,
      observe: 'response'
    }).subscribe(
      response => successCallBack(response),
      error => errorCallBack(error)
    );
  }

  //Request with login code in header
  doPostWithResponsewithLogin(
    url: string,
    data: any,
    tenantId: string,
    successCallBack: any,
    errorCallBack: any
  ) {
    url = this.addHostToUrl(url);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': tenantId
    });
    this.http.post(url, data, {
      headers: headers,
      observe: 'response'
    }).subscribe(
      (response: HttpResponse<any>) => {
        const accessToken = response.headers.get('Authorization');
        const refreshToken = response.headers.get('X-Refresh-Token');
        successCallBack(response);
      },
      (error: HttpErrorResponse) => {
        errorCallBack(error);
      }
    );
  }

  doPostRequestWithResponsewithReqHeader(url: string, data: any, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = this.headers.set('X-Tenant-ID', tenantId);
    this.http.post(url, data, { headers, observe: 'response' }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doGetRequestWithResponsewithReqHeader(url: string, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = this.headers.set('X-Tenant-ID', tenantId);
    this.http.get(url, { headers, observe: 'response' }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doPutRequestWithResponseWithReqHeader(url: string, id: number, data: any, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(`${url}/${id}`);
    const headers = this.headers.set('X-Tenant-ID', tenantId);
    this.http.put(url, data, {
      headers,
      observe: 'response'
    }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doGetResponsewithReqHeaderWithRoleId(url: string, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = this.headers.set('X-Tenant-ID', tenantId);
    this.http.get(url, { headers, observe: 'response' }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doPutRequestWithMultipart(url: string, id: number, data: FormData, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(`${url}/${id}`);
    const headers = new HttpHeaders({
      'X-Tenant-ID': tenantId
    });
    this.http.put(url, data, {
      headers,
      observe: 'response'
    }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doPostRequestWithMultipart(url: string, data: FormData, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = new HttpHeaders({
      'X-Tenant-ID': tenantId
    });
    this.http.post(url, data, {
      headers,
      observe: 'response'
    }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doPutRequestWithUrl(url: string, data: any, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = this.headers.set('X-Tenant-ID', tenantId);
    this.http.put(url, data, {
      headers,
      observe: 'response'
    }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }

  doPutRequestWithMultipartNoId(url: string, data: FormData, tenantId: string, successCallBack: any, errorCallBack: any) {
    url = this.addHostToUrl(url);
    const headers = new HttpHeaders({
      'X-Tenant-ID': tenantId
    });
    this.http.put(url, data, {
      headers,
      observe: 'response'
    }).subscribe({
      next: (response) => successCallBack(response),
      error: (error) => errorCallBack(error)
    });
  }


}
